import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ClockFilledIcon = _ref => {
  var _attributes$width, _attributes$height, _attributes$width2, _attributes$height2;
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: (_attributes$width = attributes.width) !== null && _attributes$width !== void 0 ? _attributes$width : size,
    height: (_attributes$height = attributes.height) !== null && _attributes$height !== void 0 ? _attributes$height : size,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("g", {
    clipPath: "url(#clip0_21804_69139)"
  }, __jsx("path", {
    d: "M16.5 8C16.5 12.4183 12.9183 16 8.5 16C4.08172 16 0.5 12.4183 0.5 8C0.5 3.58172 4.08172 0 8.5 0C12.9183 0 16.5 3.58172 16.5 8ZM8.5 3.5C8.5 3.22386 8.27614 3 8 3C7.72386 3 7.5 3.22386 7.5 3.5V9C7.5 9.17943 7.59614 9.3451 7.75193 9.43412L11.2519 11.4341C11.4917 11.5711 11.7971 11.4878 11.9341 11.2481C12.0711 11.0083 11.9878 10.7029 11.7481 10.5659L8.5 8.70984V3.5Z",
    fill: color
  })), __jsx("defs", null, __jsx("clipPath", {
    id: "clip0_21804_69139"
  }, __jsx("rect", {
    width: (_attributes$width2 = attributes.width) !== null && _attributes$width2 !== void 0 ? _attributes$width2 : size,
    height: (_attributes$height2 = attributes.height) !== null && _attributes$height2 !== void 0 ? _attributes$height2 : size,
    fill: "white",
    transform: "translate(0.5)"
  }))));
};
export default ClockFilledIcon;